const Signature = () => {
  return null;
}

export default Signature;